import { useEffect } from "react";

const GptLoader = () => {
  useEffect(() => {
    if (window.googletag) return;

    const script = document.createElement("script");
    script.src = "https://www.googletagservices.com/tag/js/gpt.js";
    script.async = true;
    document.head.appendChild(script);

    window.googletag = window.googletag || { cmd: [] };

    window.googletag.cmd.push(() => {
      // HEADER 728x90
      window.googletag
        .defineSlot(
          "/229445249/DWTag-DFPNew_RS70_Teluguone_Banner_728x90_100718",
          [[320, 50], [728, 90]],
          "div-gpt-header"
        )
        .addService(window.googletag.pubads());

      // SIDEBAR TOP
    //   window.googletag
    //     .defineSlot(
    //       "/229445249/DWTag-DFPNew_RS70_Teluguone_Banner_300x250_1_100718",
    //       [300, 250],
    //       "div-gpt-sidebar-1"
    //     )
    //     .addService(window.googletag.pubads());

      // SIDEBAR BOTTOM
    //   window.googletag
    //     .defineSlot(
    //       "/229445249/DWTag-DFPNew_RS70_Teluguone_Banner_300x250_2_100718",
    //       [300, 250],
    //       "div-gpt-sidebar-2"
    //     )
    //     .addService(window.googletag.pubads());

      // 1x1 tracking ad
      window.googletag
        .defineSlot(
          "/106213651/RM_Teluguone_1x1",
          [1, 1],
          "div-gpt-tracker"
        )
        .addService(window.googletag.pubads());

      window.googletag.pubads().enableSingleRequest();
      window.googletag.pubads().collapseEmptyDivs();
      window.googletag.enableServices();
    });
  }, []);

  return null;
};

export default GptLoader;